import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'assets/css/style.scss'
export default () => {
  Vue.use(BootstrapVue)
  Vue.use(IconsPlugin)
}
